/** @jsx jsx */
import { jsx } from '@emotion/react';

import CourseraMetatags from '@coursera-web/seo/components/CourseraMetatags';

import { useValueProposition } from 'bundles/browse-common/contexts/ValuePropositionContext';

const ValuePropositionMetatags = () => {
  const valuePropositionContext = useValueProposition();
  if (!valuePropositionContext) {
    return null;
  }

  return (
    <CourseraMetatags
      metaNameAndProperties={{
        title: valuePropositionContext.title,
        description: valuePropositionContext.description ?? undefined,
      }}
    />
  );
};

export default ValuePropositionMetatags;
